var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPieChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 2C13.9797 2 15.2801 2.25866 16.4933 2.76121C17.7066 3.26375 18.809 4.00035 19.7376 4.92893C20.6662 5.85752 21.4028 6.95991 21.9053 8.17317C22.4078 9.38643 22.6665 10.6868 22.6665 12M12.6665 2V12M12.6665 2C7.14366 2 2.6665 6.47715 2.6665 12C2.6665 17.5228 7.14366 22 12.6665 22C18.1894 22 22.6665 17.5229 22.6665 12M12.6665 2C18.1894 2 22.6665 6.47716 22.6665 12M22.6665 12L12.6665 12M22.6665 12C22.6665 13.5781 22.293 15.1338 21.5766 16.5399C20.8601 17.946 19.8211 19.1626 18.5444 20.0902L12.6665 12",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChartIcon);
export default __webpack_public_path__ + "static/media/pieChartIcon.b3e487033f512261f775b5a7e5cd84c6.svg";
export { ForwardRef as ReactComponent };